// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yNRec","footerContainer":"Footer_footerContainer__BbqGK","title":"Footer_title__PuebK"};